import { ExternalLink, Newspaper } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { PressKitCoverageWithId } from '../types'

interface PressKitCoverageSectionProps {
  coverage: PressKitCoverageWithId[]
}

function formatDate(ts: unknown): string {
  if (!ts) return ''
  const d =
    typeof (ts as { toDate?: () => Date }).toDate === 'function'
      ? (ts as { toDate: () => Date }).toDate()
      : new Date(ts as string | number)
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
}

export function PressKitCoverageSection({ coverage }: PressKitCoverageSectionProps) {
  return (
    <section className="space-y-4">
      <div className="grid gap-4 sm:grid-cols-2">
        {coverage.map((item) => (
          <article key={item.id} className="rounded-lg border overflow-hidden flex flex-col">
            {item.thumbnailUrl ? (
              <div className="aspect-video overflow-hidden bg-muted">
                <img
                  src={item.thumbnailUrl}
                  alt={`${item.publication} thumbnail`}
                  className="w-full h-full object-cover"
                />
              </div>
            ) : (
              <div className="aspect-video bg-muted flex items-center justify-center">
                <Newspaper className="h-8 w-8 text-muted-foreground/40" />
              </div>
            )}
            <div className="p-4 flex flex-col flex-1">
              <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-1">
                {item.publication}
                {item.coverageDate && ` · ${formatDate(item.coverageDate)}`}
              </p>
              <h3 className="text-sm font-semibold leading-snug mb-2">{item.title}</h3>
              {item.excerpt && (
                <p className="text-xs text-muted-foreground line-clamp-3 flex-1">{item.excerpt}</p>
              )}
              <div className="mt-3">
                <Button variant="outline" size="sm" asChild>
                  <a href={item.url} target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="h-3.5 w-3.5 mr-1.5" />
                    Read Article
                  </a>
                </Button>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}
